import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  const forWhom = ['Profesores de Educación Física que quieren dejar de improvisar.', 'Entrenadores Personales que buscan justificar cada ejercicio con criterio.', 'Instructores de musculación que quieren corregir errores con seguridad.', 'Estudiantes avanzados de Educación Física que necesitan una base técnica clara.', 'Profesionales que quieren aumentar la confianza de sus alumnos.'];
  const notForWhom = ['Personas que esperan resultados sin dedicar tiempo a mejorar su práctica.', 'Los que prefieren atajos rápidos sin base técnica.', 'Quienes no valoran la justificación profesional de cada ejercicio.'];
  return <section className="py-24 relative overflow-hidden" data-id="element-1">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-2">
        <FadeIn className="text-center mb-16" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-4">
            ¿Es este pack para vos?
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-5">
            Diseñado específicamente para quienes se toman en serio su
            profesión.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-6">
          {/* Para Quién Es */}
          <FadeIn delay={0.2} data-id="element-7">
            <div className="bg-card border border-green-500/20 rounded-3xl p-8 md:p-12 h-full shadow-2xl relative overflow-hidden" data-id="element-8">
              <div className="absolute top-0 right-0 w-64 h-64 bg-green-500/5 rounded-full blur-3xl" data-id="element-9" />
              <div className="flex items-center gap-4 mb-8" data-id="element-10">
                <div className="w-12 h-12 rounded-full bg-green-500/10 flex items-center justify-center" data-id="element-11">
                  <CheckCircleIcon className="w-6 h-6 text-green-500" data-id="element-12" />
                </div>
                <h3 className="text-2xl font-bold text-white" data-id="element-13">
                  Para Quién Sí Es
                </h3>
              </div>
              <ul className="space-y-6" data-id="element-14">
                {forWhom.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-15">
                    <CheckCircleIcon className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-16" />
                    <span className="text-lg text-gray-300 leading-relaxed" data-id="element-17">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para Quién No Es */}
          <FadeIn delay={0.4} data-id="element-18">
            <div className="bg-background border border-red-500/20 rounded-3xl p-8 md:p-12 h-full shadow-2xl relative overflow-hidden" data-id="element-19">
              <div className="absolute top-0 right-0 w-64 h-64 bg-red-500/5 rounded-full blur-3xl" data-id="element-20" />
              <div className="flex items-center gap-4 mb-8" data-id="element-21">
                <div className="w-12 h-12 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-22">
                  <XCircleIcon className="w-6 h-6 text-red-500" data-id="element-23" />
                </div>
                <h3 className="text-2xl font-bold text-white" data-id="element-24">
                  Para Quién No Es
                </h3>
              </div>
              <ul className="space-y-6" data-id="element-25">
                {notForWhom.map((item, index) => <li key={index} className="flex items-start gap-4 opacity-70" data-id="element-26">
                    <XCircleIcon className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-27" />
                    <span className="text-lg text-gray-400 leading-relaxed" data-id="element-28">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}